import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsSliderHor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSettingsSliderHor"><Path d="M9 13C10.8645 13 12.4302 14.2744 12.874 16H21V18H12.874C12.4302 19.7256 10.8645 21 9 21C7.13554 21 5.56982 19.7256 5.12598 18H3V16H5.12598C5.56982 14.2744 7.13554 13 9 13ZM15 3C16.8645 3 18.4302 4.27443 18.874 6H21V8H18.874C18.4302 9.72557 16.8645 11 15 11C13.1355 11 11.5698 9.72557 11.126 8H3V6H11.126C11.5698 4.27443 13.1355 3 15 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsSliderHor;
